/** Created by azhou on 2019/1/17.*/
<template>
  <div class="pt-5">
          <el-image
        style="width: 200px; height: 200px"
        :src="wechatAvatar"
        class="image-slot"
      >
      <div slot="error" ></div>
    </el-image>
    <div class="m-4 text-info">
      <p class="mb-2">关注订单雨，您将可以接收到订单消息的提醒，订单状态变更的通知等</p>
      <p>一个微信号只能绑定一个账号，若原来已绑定其他账号，则原来账号微信绑定失效</p>
    </div>
    <el-button  type="primary"  @click="skipBind()"  block>跳过、稍后绑定</el-button>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name: 'RegWechat',
    computed: {
      ...mapState(['userLoginMessage', 'wechatInfo']),
      ...mapGetters(['userInfo','isGroup']),
      //组件被引用的当前页面是否为注册页面（重新绑定微信信息页面）
      // isRegisterPage () {}
    },
    data () {
      return {
        wechatAvatar: '',
      }
    },
    watch: {
      wechatInfo (newVal) {
        if (newVal.openid) {                                                      //微信绑定成功
          this.$message.success('微信绑定成功！')
          this.updateInfo()
          this.wechatAvatar = newVal.avatar                                       //将绑定二维码换成用户头像
          this._timeout = setTimeout(() => {                                      //300毫秒后跳转到下一个页面
            let verify = Number(this.userLoginMessage.status);
            if (verify === 1) {
              this.$router.push({name:'CenterIndex'})
              return
            };
            //供应商-销售、登录跳转主页或关联页面
            if(userInfo.type==2||userInfo.type==3){
              this.$router.push({name:'regBasicClose',query:{step:1}});
              return
            }
            // //采购商跳转填写门店信息
            // if(userInfo.type==2){
            //    this.$router.push({name:'resBasicInfo'});
            //    return
            // }
          }, 300)
        }
      }
    },
    created () {
      this.getQRCode()
      this._timer = setInterval(this.getQRCode, 4 * 60 * 1000)
    },
    beforeDestroy () {
      clearInterval(this._timer);                                                 //清除循环获取微信绑定二维码的定时器
      clearTimeout(this._timeout);                                                //清除微信绑定成功之后延时跳转的定时器
    },
    methods: {
      ...mapActions(['updateInfo']),
      /*获取微信绑定二维码*/
      async getQRCode () {
        let res = await this.$axios.post('/pc/AuthAndBind/getWechatQrcode', {});
        if (res.code === '00000') this.wechatAvatar = res.info.path; 
      },
      /*跳过绑定微信*/
      skipBind () {
        let userLoginMessage=this.userLoginMessage;
          //已绑定微信的集团用户直接去会员中心
          if (userLoginMessage.status === 1||userLoginMessage.type==2) {
            this.$router.push({ name: 'CenterIndex'});
            return
          }
          //供应商-销售、登录跳转主页或关联页面
          if ([2,3].includes(userLoginMessage.status) && userLoginMessage.type === 3) {
            this.$router.push({ name: 'regBasicClose'});
            return
          }
      }
    }
  }
</script>
<style scoped>
  .image-slot{
    background-color:#f5f5f5;
    display: block;
    border-radius: 10px;
    margin: 0 auto;
  }
</style>